import { Link } from "react-router-dom";
import Icon from "./Icon";
import MetaBadge from "./MetaBadge";

const platforms = [
  { name: "WhatsApp", icon: "bi-whatsapp", href: "https://wa.odinno.com" },
  { name: "Meta", icon: "bi-meta" },
  { name: "Facebook", icon: "bi-facebook" },
  { name: "Instagram", icon: "bi-instagram" },
];

const features = [
  "Official WhatsApp Cloud API",
  "Meta Ads Automation",
  "Real-time Webhooks",
  "99.9% Uptime",
];

const stats = [
  { value: "50+", label: "Projects Delivered" },
  { value: "100+", label: "Clients Worldwide" },
  { value: "5+", label: "Years of Expertise" },
  { value: "24/7", label: "Expert Support" },
];

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__aurora hero__aurora--a" aria-hidden="true" />
      <div className="hero__aurora hero__aurora--b" aria-hidden="true" />
      <div className="hero__grid" aria-hidden="true" />
      <div className="hero__orb hero__orb--a" aria-hidden="true" />
      <div className="hero__orb hero__orb--b" aria-hidden="true" />
      <div className="container hero__inner reveal reveal--visible">
        <MetaBadge
          className="hero__badge"
          label="WhatsApp Cloud API & Meta Solutions Experts"
        />
        <p className="eyebrow">Odinno · OnDemand Innovation · Digital Company</p>
        <div className="hero__status">
          <span className="hero__status-dot" aria-hidden="true" />
          <i className="bi bi-cpu-fill hero__status-cpu" />
          AI-Optimized Platform · Systems Online
        </div>
        <h1 className="hero__title">
          <span className="gradient-text">Digital Innovation</span>{" "}
          <span className="hero__title-accent">
            That Drives Business Growth
          </span>
        </h1>
        <p className="hero__lead">
          Odinno is a full-service digital company — from the official WhatsApp
          Business API and Meta platform integrations to custom software, AI and
          cloud solutions — helping businesses build, automate and scale with
          confidence.
        </p>
        <div className="hero__cta">
          <Link className="btn btn--primary" to="/services">
            Explore Our Services
            <Icon name="arrow" size={16} />
          </Link>
          <Link className="btn btn--ghost" to="/contact">
            Start Your Project
          </Link>
        </div>

        <div className="hero__platforms">
          {platforms.map((platform) => {
            const Cmp = platform.href ? "a" : "span";
            return (
              <Cmp
                className="platform-chip"
                key={platform.name}
                {...(platform.href
                  ? {
                      href: platform.href,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    }
                  : {})}
              >
                <i className={`bi ${platform.icon}`} />
                {platform.name}
              </Cmp>
            );
          })}
        </div>

        <div className="hero__chips">
          {features.map((feature) => (
            <span className="hero__chip" key={feature}>
              <i className="bi bi-check-circle-fill hero__chip-icon" />
              {feature}
            </span>
          ))}
        </div>
{/* 
        <div className="hero__stats">
          {stats.map((stat) => (
            <div className="hero__stat" key={stat.label}>
              <strong className="hero__stat-value gradient-text">{stat.value}</strong>
              <span className="hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}

export default Hero;
